import type {DecorationPlugin, DecorationSingleComponentPlugin} from '../../types'
import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'
import {unpack} from './unpack'

export const imageXPluginSingleComponentPlugin = {
    name: 'ImageXPlugin',
    components: new Set(['ImageX']),
    pack,
    unpack
} satisfies DecorationSingleComponentPlugin

export const imageXPlugin: DecorationPlugin = createPluginFromSingleComponentPlugin(imageXPluginSingleComponentPlugin)
